import React from 'react';

interface GameTitleProps {
    title: string;
    subtitle?: string;
}

const GameTitle: React.FC<GameTitleProps> = ({ title, subtitle }) => {
    return (
        <div style={{
            textAlign: 'center',
            marginBottom: '30px',
            padding: '20px',
            paddingTop: '10px',
            paddingBottom: '10px',
            background: 'linear-gradient(135deg, rgba(47,27,20,0.9) 0%, rgba(139,69,19,0.8) 50%, rgba(210,180,140,0.7) 100%)',
            borderRadius: '15px',
            // border: '3px solid #FFD700',
            boxShadow: '0 12px 35px rgba(0,0,0,0.5), 0 0 20px rgba(255,215,0,0.3)',
            animation: 'titleGlow 2s ease-in-out infinite alternate',
            minWidth: '400px'
        }}>
            <div style={{
                color: '#FFD700',
                fontWeight: 'bold',
                marginBottom: '15px',
                textAlign: 'center',
                fontSize: '32px',
                textShadow: '2px 2px 6px rgba(0,0,0,0.8), 0 0 15px rgba(255,215,0,0.5)',
                letterSpacing: '2px'
            }}>
                🏜️ {title} 🐪
            </div>
            {subtitle && (
                <div style={{
                    color: '#F4E4BC',
                    fontSize: '18px',
                    lineHeight: '1.4',
                    padding: '10px',
                    background: 'rgba(255,215,0,0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(255,215,0,0.3)',
                    fontWeight: '500'
                }}>
                    {subtitle}
                </div>
            )}

            <style>{`
                @keyframes titleGlow {
                    0% { box-shadow: 0 12px 35px rgba(0,0,0,0.5), 0 0 20px rgba(255,215,0,0.3); }
                    100% { box-shadow: 0 12px 35px rgba(0,0,0,0.5), 0 0 35px rgba(255,215,0,0.5); }
                }
            `}</style>
        </div>
    );
};

export default GameTitle; 